var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{ref:"iframeRef",staticClass:"chatbot-iframe",class:{
    'rounded-full': _vm.size.width === '56px',
    'rounded-2xl': _vm.size.width !== '56px'
  },style:(_vm.computedStyle),attrs:{"src":_vm.CHATBOT_ORIGIN,"title":"Chatbot","allow":"clipboard-write; microphone"}})}
var staticRenderFns = []

export { render, staticRenderFns }